module.exports = __webpack_public_path__ + "img/13932863_1588564664770934_1013832754847865201_n.ea2cea3e.jpg";